import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function strongPasswordValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    if (!value) {
      return null; // Use Validators.required instead
    }

    // 8+ characters, 1 uppercase, 1 lowercase, 1 number, 1 special char
    const pattern =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=[\]{}|;:'",.<>/?]).{8,}$/;

    const valid = pattern.test(value);
    return valid ? null : { strongPassword: true };
  };
}
